import type { MonospaceSettings } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { SINGLETON_KEY } from '#layers/workspace/public';

export const Settings = RStoreSchema.withItemType<MonospaceSettings>().defineCollection({
	getKey: () => SINGLETON_KEY,
	name: 'MonospaceSettings',
	scopeId: 'monospace-default',
	meta: {
		singleton: true,
		defaultFields: ['id'],
		endpoint: 'settings',
		useWorkspaceSlug: true,
	},
});
